<template>
  <div class="recommend-focus-news-item-container">
    <a target="_blank" class="focus-news-item-title" :href="data.url">{{data.title}}</a>
    <div v-for="(item, index) in data.monitor_companies" :key="index" class="row focus-news-item-companies">
      <div @click="toCompanyDetail(item.name)" class="focus-news-item-company">{{item.stock_code}}</div>
      <RecommendEventPopover :item="item"></RecommendEventPopover>
      <div></div>
    </div>
    <div v-for="(item, index) in data.related_companies" :key="index" class="focus-news-item-companies">
      <div class="row">
        <div @click="toCompanyDetail(item.name)" class="focus-news-item-company">
          <span>{{item.stock_code}}</span>
          <!-- <span class="focus-event-news-item-relation">({{item.monitor_company}}-{{item.relation_with_monitor_company}})</span> -->
        </div>
        <ConcernRelatedCompanyPopover :item="item"></ConcernRelatedCompanyPopover>
        <div></div>
      </div>
      <div class="row relation-with-monitor-company">
        <div class="relation-with-monitor-company-item" v-for="(i, idx) in item.related_monitor_company" :key="idx">
          <div>[{{i.monitor_company}}-{{i.relation_with_monitor_company}}]</div>
        </div>
      </div>
    </div>
    <div class="row focus-news-item-source-date">
      <div class="focus-news-item-source">{{data.source}}</div>
      <div>{{data.date}}</div>
    </div>
  </div>
</template>

<script>
import RecommendEventPopover from '@/components/recommend/RecommendEventPopover';
import ConcernRelatedCompanyPopover from '@/components/concern/ConcernRelatedCompanyPopover';

export default {
  name: 'recommend-news-list-item',
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    toCompanyDetail(res) {
      const routeUrl = this.$router.resolve({
        path: '/result', 
        query: {
          q: res
        }  
      });
      window.open(routeUrl.href, '_blank');
    }
  },
  components: {
    RecommendEventPopover,
    ConcernRelatedCompanyPopover
  }
};
</script>

<style lang="scss" scoped>
  .recommend-focus-news-item-container {
    padding: 16px 0;
    box-shadow: inset 0px -1px 0px 0px#f7f7fa;
    .focus-news-item-title {
      display: inline-block;
      margin-bottom: 8px;
      color: #171f46;
      font-size: 16px;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .focus-news-item-companies {
      // flex-wrap: wrap;
      .relation-with-monitor-company {
        flex-wrap: wrap;
        .relation-with-monitor-company-item {
          margin-bottom: 4px;
          margin-right: 8px;
          color: #747990;
          font-size: 12px;
        }
      }
      .focus-news-item-company {
        margin: 0 8px 4px 0;
        padding: 0 8px;
        border-radius: 2px;
        border: solid 1px rgba(69, 168, 204, 0.4);
        color: rgba(69, 168, 204, 0.8);
        font-size: 14px;
        cursor: pointer;
        &:hover {
          border: 1px solid #45a8cc;
          color: #45a8cc;
        }
        .focus-event-news-item-relation {
          color: #9ea1b4;
          font-size: 12px;
        }
      }
    }
    .focus-news-item-source-date {
      margin-top: 4px;
      height: 17px;
      line-height: 17px;
      color: #9ea1b4;
      font-size: 12px;
      .focus-news-item-source {
        margin-right: 10px;
      }
    }
  }
</style>

